
































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import moment, { Moment } from 'moment';
import storage from 'baimahu/storage';
import { date } from '@/util/adapter';
const uuidv4 = require('uuid/v4');
const dateFormat = require('bmh/date-format');
const { VUE_APP_FCREST: FCREST } = process.env;
import { ActivityType, OnlineStatus } from './config';
const API = {
  query: `${FCREST}/promotion/shang/activity`,
  userInfo: `${FCREST}/promotion/shang/merchant`,
};

@Component
export default class ActivityConfig extends Vue {
  is_loading: boolean = false;
  now_time_stamp: number = 0;
  page: number = 1;
  modal_page: number = 1;
  form: any = {
    activity_status: 0,
    activity_type: 0,
    online_status: 0,
    payTime: [],
  };
  activity_id: any = '';
  require_modal: string = '';
  activity_status: SelectOption[] = [
    {
      label: '全部',
      value: 0,
    },
    {
      label: '未开始',
      value: 1,
    },
    {
      label: '进行中',
      value: 2,
    },
    {
      label: '已结束',
      value: 3,
    },
  ];
  activity_type: SelectOption[] = [
    {
      label: '全部',
      value: 0,
    },
    {
      label: '普通活动',
      value: ActivityType.normal,
    },
    {
      label: '直播活动',
      value: ActivityType.live,
    },
  ];
  online_status: SelectOption[] = [
    {
      label: '全部',
      value: 0,
    },
    {
      label: '已上架',
      value: OnlineStatus.online,
    },
    {
      label: '已下架',
      value: OnlineStatus.offline,
    },
  ];
  table_data: any = {};
  modal_data: any = {};
  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }
  paginationOption(data: any) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.size}条`,
      pageSize: data.size || 1,
      current: data.current || 1,
    };
  }

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  // 搜索
  async query(page: number = 1) {
    this.is_loading = true;
    this.page = page;
    const send_data: any = {};
    send_data.page = this.page;
    send_data.name = this.form.name;
    if (this.form.payTime && this.form.payTime.length === 2) {
      send_data.start_time = this.form.payTime[0].format('X');
      send_data.end_time = this.form.payTime[1].format('X');
    }
    if (this.form.activity_status !== 0) {
      send_data.status = this.form.activity_status;
    }
    if (this.form.activity_type !== 0) {
      send_data.activity_type = this.form.activity_type;
    }
    if (this.form.online_status !== 0) {
      send_data.is_show = this.form.online_status;
    }
    const profile = storage.getItem('profile') || {};
    const merchant_id = profile.merchant_id || '';
    send_data.merchant_id = merchant_id;
    const res = await this.$axios.get(API.query, { params: send_data });
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    const data_row = res.data.data ? res.data.data.data : [];
    const now_time = new Date().valueOf();
    const now_time_str = JSON.stringify(now_time / 1000);
    this.now_time_stamp = parseInt(now_time_str, 10);
    this.table_data = res.data.data ? res.data.data : {};
    if (this.table_data && this.table_data.data) {
      this.table_data.data.map((item: any) => {
        item._key = uuidv4();
        if (this.now_time_stamp < item.start_time) {
          item.activity_status = '未开始';
        } else if (this.now_time_stamp < item.end_time) {
          item.activity_status = '进行中';
        } else if (this.now_time_stamp > item.end_time) {
          item.activity_status = '已结束';
        }
        item.start_time = this.dateFormat(item.start_time);
        item.end_time = this.dateFormat(item.end_time);
        item.today_award_amount = item.today_award_amount / 100;
        item.award_amount = item.award_amount / 100;
        item.is_online = !!item.is_show ? item.is_show === 1 : false;
        item.slideshow = item.slideshow.split(',')[0];
        item.type_text =
          item.activity_type === ActivityType.live
            ? '直播活动'
            : '普通活动';
        return item;
      });
    }
    this.is_loading = false;
  }

  // 获取弹窗中数据
  queryModal(page: number = 1) {
    this.is_loading = true;
    this.modal_page = page;
    const send_data: any = {};
    send_data.page = this.modal_page;
    send_data.activity_id = this.activity_id;
    this.$axios
      .get(this.require_modal, { params: send_data })
      .then((res: AxiosResponse) => {
        if (res.status !== 200) {
          this.$message.error(res.data.message);
          return;
        }
        this.modal_data = res.data.data;
      })
      .finally(() => {
        this.is_loading = false;
      });
  }

  // 新增活动按钮
  addActivity() {
    this.$router.push({
      path: '/activity/config-first',
    });
  }

  // 清空搜索条件
  clearForm() {
    this.form.name = undefined;
    this.form.time = [];
    this.form.activity_status = undefined;
  }

  async created() {
    await this.query();
  }
}
